export default __webpack_public_path__ + "static/media/stop.d64d0117.svg";